import { render, staticRenderFns } from "./actMaleRank.vue?vue&type=template&id=89e8657e&scoped=true"
import script from "./actMaleRank.vue?vue&type=script&lang=js"
export * from "./actMaleRank.vue?vue&type=script&lang=js"
import style0 from "./actMaleRank.vue?vue&type=style&index=0&id=89e8657e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e8657e",
  null
  
)

export default component.exports